module.exports = __webpack_public_path__ + "img/Carousel-funcionalidades-icono-05.1701d965.svg";